import type { TFunction } from 'i18next';
import type { ContentTheme } from '@/types';

export function getGreeting(t: TFunction): string {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return t('greeting.morning');
  if (hour >= 12 && hour < 18) return t('greeting.afternoon');
  return t('greeting.evening');
}

export function formatTimeAgo(dateString: string, t: TFunction): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);

  if (diffHours < 1) return t('time.now');
  if (diffHours < 24) return t('time.hoursAgo', { count: diffHours });
  if (diffDays < 7) return t('time.daysAgo', { count: diffDays });
  if (diffWeeks < 5) return t('time.weeksAgo', { count: diffWeeks });
  return t('time.monthsAgo', { count: diffMonths });
}

export function calculateReadingTime(html?: string): number {
  if (!html) return 1;
  const text = html.replace(/<[^>]*>/g, '');
  const wordCount = text.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(wordCount / 200));
}

export function getThemeLabel(theme: ContentTheme, t: TFunction): string {
  return t(`themes.${theme}`, { defaultValue: theme });
}
